import { render } from "./BookSpace.vue?vue&type=template&id=f115cb9a&scoped=true"
import script from "./BookSpace.vue?vue&type=script&lang=js"
export * from "./BookSpace.vue?vue&type=script&lang=js"

import "./BookSpace.vue?vue&type=style&index=0&id=f115cb9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f115cb9a"]])

export default __exports__